// Short, readable forms of decrypted event content for the conversation view.
import { messages } from "../i18n";

/** A conversation's kind ("run", "task"…) in the active language; an unknown one as sent. */
export function conversationKind(kind: string): string {
  const kinds: Partial<Record<string, string>> = messages().conversation.kinds;
  return kinds[kind] ?? kind.replaceAll("_", " ");
}

/**
 * A one-line summary of a `tool_use` block (`{"name", "input"}`) or `tool_result` block:
 * the command, path, pattern or URL it acted on, else its text, else nothing.
 */
export function toolSummary(plaintext: string): string {
  let block: unknown;
  try {
    block = JSON.parse(plaintext);
  } catch {
    return plaintext.slice(0, 160);
  }
  if (!block || typeof block !== "object") return "";
  const b = block as Record<string, unknown>;
  const input = b.input && typeof b.input === "object" ? (b.input as Record<string, unknown>) : undefined;
  for (const key of ["command", "file_path", "path", "pattern", "url", "description", "query"]) {
    const v = input?.[key];
    if (typeof v === "string" && v !== "") return v.slice(0, 160);
  }
  if (typeof b.content === "string") return b.content.slice(0, 160);
  if (Array.isArray(b.content)) {
    const text = b.content.find((c): c is { text: string } => !!c && typeof c === "object" && typeof (c as { text?: unknown }).text === "string");
    if (text) return text.text.slice(0, 160);
  }
  return "";
}
